import React from "react";
import CircularProgress from "@material-ui/core/CircularProgress";

import FieldManagement from "../field-management";

import { LoaderWrapper } from "./styles";

const FromFileLineItem = props => {
  const { isLoading } = props;

  if (isLoading) {
    return (
      <LoaderWrapper>
        <CircularProgress size={40} style={{ color: "#005AA9" }} />
      </LoaderWrapper>
    );
  }

  return <FieldManagement {...props} />;
};

export default FromFileLineItem;
